import request from "@/utils/request";

//首页分类
export const reqCategory = () => request({ url: `/product/getBaseCategoryList`})
